import { VStack } from 'tio-reimagined/components/layout';
import NewTypeTwoOrThreeApp from 'tio-employee/components/tas/applications/new/type-two-or-three';
import type { TOC } from '@ember/component/template-only';
import type TasApplicationModel from 'tio-data/models/tas-application';
import type TASProgramInstanceModel from 'tio-data/models/tas-program-instance';
import type TasUnifiedInstitutionModel from 'tio-data/models/tas-unified-institution';

export interface S {
  Args: {
    model: {
      application: TasApplicationModel;
      programInstance: TASProgramInstanceModel;
      selectedSchool: TasUnifiedInstitutionModel | undefined;
    };
  };
}

const tmpl: TOC<S> = <template>
  <VStack>
    <NewTypeTwoOrThreeApp @model={{@model}} />
  </VStack>
</template>;

export default tmpl;
